import { MatHorizontalStepper } from '@angular/material';
import { StepperServiceVM } from 'src/app/view-model/services/stepper-vm.service';

export class StepperProviderVM extends StepperServiceVM {

    stepper: MatHorizontalStepper = null;

    get currentStep(): number {
      let step = 0;
      if (this.stepper) {
        step = this.stepper.selectedIndex;
      }
      return step;
    }

    configure(stepper: MatHorizontalStepper): void {
        this.stepper = stepper;
    }

    nextStep(): void {
      if (this.stepper) {
        this.stepper.next();
      }
    }

}
